module.exports = __webpack_public_path__ + "static/diagram-d0cc231f311edde6c8191320b3251a65.png";